import ajax from "./ajax";

export function getContentsByType(type) {
  return ajax(`/contents?ContentsSearch[type]=${type}&per-page=1000`);
}
